import { render, staticRenderFns } from "./LettersRecordsTable.vue?vue&type=template&id=80111b28&"
import script from "./LettersRecordsTable.vue?vue&type=script&lang=js&"
export * from "./LettersRecordsTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports